export const SITE_URL = 'https://lexoya.com'
export const CONSOLE_URL = 'https://console.lexoya.com'

export const consoleLoginUrl = `${CONSOLE_URL}/login`

export const newTicketUrl = `${CONSOLE_URL}/tickets/create`

export const contactPath = (lang: string) => `/${lang}/contact`
